import React from "react";
// import { FaCompass } from "react-icons/fa";

const Summary = ({ players, history }) => {
  const games = history.reduce((a, b) => a + b.player1 + b.player2, 0);
  const player1Points = history.reduce((a, b) => a + (b.player1 > b.player2 ? b.player1 - b.player2 : 0), 0);
  const player2Points = history.reduce((a, b) => a + (b.player2 > b.player1 ? b.player2 - b.player1 : 0), 0);
  const player1Games = history.reduce((a, b) => a + b.player1, 0);
  const player2Games = history.reduce((a, b) => a + b.player2, 0);
  const player1Avg = (player1Points / history.length).toFixed(2);
  const player2Avg = (player2Points / history.length).toFixed(2);

  return (
    <div className="flex pb-8">
      <div className="w-1/2 pr-4 lg:pr-12 border-r border-line">
        <h5 className="font-header font-semibold text-front text-sm uppercase">Summary</h5>
        <div className="font-header font-light text-xl text-front leading-tight">
          <div>
            <br />
            <p>
              {players.player1.name}: {player1Points} points
              <br />
              {player1Games} games won
              <br />
              {player1Avg} avg. points per session
            </p>
            <br />
            <p>
              {players.player2.name}: {player2Points} points
              <br />
              {player2Games} games won
              <br />
              {player2Avg} avg. points per session
            </p>
          </div>
        </div>
      </div>
      <div className="w-1/2 pl-4 lg:pl-12">
        <h5 className="font-header font-semibold text-front text-sm uppercase">Stats</h5>
        <div className="font-header font-light text-xl text-front leading-tight">
          <div>
            <br />
            Sessions Played: {history.length}
            <br />
            Games Played: {games}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
